import React, { useState, useEffect, useSelector } from "react";
import {
  getCompany,
  getLogbookById,
  getInternReportById,
  postAddProposal,
  getProposalById,
  putProposal,
  getDocumentReqStudent,
  getInternshipRequestBySt_id,
  getInternManualById,
  getInternStudent,
  getCoopReportById,

} from "../api/crud";
import { engApi } from "../api/engApi";
import {
  postAddLogbook,
  postEditLogbook,
  postAddInternReport,
  postEditInternReport,
  postAddCoopReport,
  postEditCoopReport,
} from "./../api/crud";
import { convertDateToString, matchOptions } from "../utils/function";
import { GiFactory } from "react-icons/gi";
import { Link } from "react-router-dom";
import { internType } from "../data/interntype-data";
import { BsPencilSquare } from "react-icons/bs";
import PDFPreview from "./PDFPreview";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Typography,
  Button,
  Grid,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GrDocumentVerified } from "react-icons/gr";
import ModalView from "./ModalView";
import InternPageReview from "./InternPageReview";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Rating from "@mui/material/Rating";
import InternStdDetail from "./InternStdDetail";
import { set } from "lodash";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { updateSnackbar } from "../redux/action/dataAction";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { Assignment, ModeEdit } from "@mui/icons-material";
import { tr } from "date-fns/locale";


const InternData = ({ st_id }) => {
  const [internDetail, setInternDetail] = useState([]);
  const [optionsCompany, setOptionsCompany] = useState([]);
  const [optionstaff, setOptionsStaff] = useState([]);
  const getUsername = localStorage.getItem("username");
  const [onEdit, setOnEdit] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const [logbooklist, setLogbookList] = useState([]);
  
  const [modalAddLogbookPreviewOpen, setModalAddLogbookPreviewOpen] =
    useState(false);

  const [modalAddProposalPreviewOpen, setModalAddProposalPreviewOpen] =
    useState(false);

  const [modalEditLogbookPreviewOpen, setModalEditLogbookPreviewOpen] =
    useState(false);

  const [modalAddInternReportPreviewOpen, setModalAddInternReportPreviewOpen] =
    useState(false);
  const [modalAddCoopReportPreviewOpen, setModalAddCoopReportPreviewOpen] =
    useState(false);

  const [modalEditInternReportPreviewOpen,setModalEditInternReportPreviewOpen,] 
  = useState(false);
  const [modalEditCoopReportPreviewOpen,setModalEditCoopReportPreviewOpen,] 
  = useState(false);
  
  const [addLogbookReq_ID, setAddLogbookReq_ID] = useState();
  const { register, control, watch, setValue } = useForm({});
  const dispatch = useDispatch();
  const [internManualDetail, setInternManualDetail] = useState([]);
 
 
  const reload = () => window.location.reload();
  const handleCloseAddLogbookModal = () => {
    setModalAddLogbookPreviewOpen(false);
    // reload();
    getInternData();
  };

  const handleCloseEditLogbookModal = () => {
    setModalEditLogbookPreviewOpen(false);
    // reload();
    getInternData();
  };

  const handleCloseAddInternReportModal = () => {
    setModalAddInternReportPreviewOpen(false);
    // reload();
    getInternData();
  };

  const handleCloseEditInternReportModal = () => {
    setModalEditInternReportPreviewOpen(false);
    // reload();
    getInternData();
  };

  
  const handleCloseAddCoopReportModal = () => {
    setModalAddCoopReportPreviewOpen(false);
    // reload();
    getInternData();
  };

  const handleCloseEditCoopReportModal = () => {
    setModalEditCoopReportPreviewOpen(false);
    // reload();
    getInternData();
  };


  const handleCloseAddProposalModal = () => {
    setModalAddProposalPreviewOpen(false)
    // reload();
    getInternData();
  };


  const onAddLogbook = (item, no) => {
    setModalAddLogbookPreviewOpen(true);
    setValue("logbook.req_id", item);
    setValue("logbook.no", no);
    setValue("logbook.link", null);
  };

  const onEditLogbook = (item, no, link) => {
    setModalEditLogbookPreviewOpen(true);
    setValue("logbook.req_id", item);
    setValue("logbook.no", no);
    setValue("logbook.link", link);
  };
  const onAddProposalCoop = (item) => {
    // item?.req_id, item?.proposal?.link;

    setModalAddProposalPreviewOpen(true);

    setValue("proposalCoop.req_id", item?.req_id);
    setValue("proposalCoop.link", item?.proposal[0]?.link);
    setValue("proposalCoop.id", item?.proposal[0]?.id);
  };

  const onAddInternReport = (item) => {
    setModalAddInternReportPreviewOpen(true);
    setValue("internreport.req_id", item);
    setValue("internreport.link", null);
  };

  const onAddCoopReport = (item) => {
    setModalAddCoopReportPreviewOpen(true);
    setValue("coopreport.req_id", item);
    setValue("coopreport.link", null);
  };

  const onEditInternReport = (item, link) => {
    setModalEditInternReportPreviewOpen(true);
    setValue("internreport.req_id", item);
    setValue("internreport.link", link);
  };

  const onEditCoopReport = (item, link) => {
    setModalEditCoopReportPreviewOpen(true);
    setValue("coopreport.req_id", item);
    setValue("coopreport.link", link);
  };


  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const onEditClick = () => {
    setOnEdit(!onEdit);
  };

  const fetchLogbook = (id) => {
    try {
      getLogbookById(id)
        .then((res) => {
         // console.log("log", res);
          setLogbookList(res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const getInternData = async () => {
    //const response = await engApi.get("/get-internship-request/");
    const response = await getInternshipRequestBySt_id(st_id); 
    
    const allStaff = await engApi.get("/all-staff/");
    //const documentReqStudent = await getDocumentReqStudentById(st_id);
    const logbooks = await getLogbookById(st_id);
    setLogbookList(logbooks);
    
    const proposal = await getProposalById(st_id);
    const documentReqStudent = await getDocumentReqStudent();

    // const studentIntern = await getInternStudent();
    // const studentInternFilter = studentIntern?.filter(
    //   (el) => el.id == st_id
    // );
    
    const listInternReq = await response.map((item, index) => {
      const documentReqStudent1 = documentReqStudent?.find(
        (el) => el.st_id == st_id && el.cp_id == item?.cp_id
      );
      return {
        ...item,
        documentReqStudent: documentReqStudent1,
      };
    });

    
    const internReport = await getInternReportById(st_id);
    const coopReport = await getCoopReportById(st_id);

    
        try {
          //const response_yrs = await engApi.get("/getSchoolYear/");
          //console.log("listInternReq", listInternReq);
          const schoolYear = listInternReq[0]?.school_yrs;
          const match =  listInternReq?.filter((el) => el.school_yrs == schoolYear);
             
          const list = await match.map((item, index) => {
            const companySelected = optionsCompany?.find(
              (el) => el.value == item?.cp_id
            );
            const supervisor = allStaff.data?.find(
              (el) => el?.id == item?.supervisor
            );
          const internReportFilter = internReport?.filter(
            (el) => el.req_id == item?.req_id
          );

          const coopReportFilter = coopReport?.filter(
            (el) => el.req_id == item?.req_id
          );

          const proposalFilter = proposal?.filter(
            (el) => el.req_id == item?.req_id
          );
          
          
          return {
              ...item,
              companyDetail: companySelected,
              supervisorName: supervisor?.name,
              internreport: internReportFilter,
              proposal: proposalFilter,
              coopreport: coopReportFilter,
              //documentReqStudent: documentReqStudent1,
              //logbook: item?.req_id == logbooklist?.req_id ?? logbooklist,
            };
          });

          if (list.length) {
            setInternDetail(list);
          }
        } catch (err) {
          console.log(err);
        }
      };


  const onHandleAddLogbook = async (reqId, no, link) => {
    try {
      //console.log("reqId",reqId,"no",no,"link",link);
      await postAddLogbook(reqId, no, link);

      handleCloseAddLogbookModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const onHandleAddProposal = async (reqId, link) => {
    try {
      await postAddProposal(reqId, link);
      // await putProposal(reqId, link);

      handleCloseAddProposalModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const onHandleEditProposal = async (reqId, link) => {
    try {
      await putProposal(reqId, link);

      handleCloseAddProposalModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const onHandleAddInternReport = async (reqId, link) => {
    try {
      //console.log("reqId",reqId,"no",no,"link",link);
      await postAddInternReport(reqId, link);

      handleCloseAddInternReportModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const onHandleAddCoopReport = async (reqId, link) => {
    try {
      //console.log("reqId",reqId,"no",no,"link",link);
      await postAddCoopReport(reqId, link);

      handleCloseAddCoopReportModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const onHandleEditLogbook = async (reqId, no, link) => {
    try {
      //console.log("reqId",reqId,"no",no,"link",link);
      await postEditLogbook(reqId, no, link);

      handleCloseEditLogbookModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const onHandleEditInternReport = async (reqId, link) => {
    try {
      //console.log("reqId",reqId,"no",no,"link",link);
      await postEditInternReport(reqId, link);

      handleCloseEditInternReportModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const onHandleEditCoopReport = async (reqId, link) => {
    try {
      //console.log("reqId",reqId,"no",no,"link",link);
      await postEditCoopReport(reqId, link);

      handleCloseEditCoopReportModal();
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );
    } catch (err) {
      console.warn(err);
    }
  };

  const displayModalProposalPreview = (
    <ModalView
      isModaOpen={modalAddProposalPreviewOpen}
      setIsModalOpen={setModalAddProposalPreviewOpen}
      onClose={() => {
        setModalAddProposalPreviewOpen(false);
      }}
      title="แจ้งรายละเอียดโครงงานสหกิจศึกษาและการปฏิบัติงานสหกิจศึกษา"
    >
      <Box sx={{ 
        minWidth: "400px", 
        maxWidth: "600px", 
        maxHeight: "80vh",
        padding: "16px",
        overflowY: "auto"
      }}>
        <Grid container spacing={3}>
          {/* Header Information Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#e8f5e8', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #c3e6cb',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#155724', fontWeight: 600, fontSize: '1.1rem' }}>
                🎓 ข้อมูลโครงงาน
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#155724' }}>
                    Request ID
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#f8fff9',
                      border: '1px solid #c3e6cb',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`proposalCoop.req_id`)}
                    readOnly
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Google Drive Link Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                📋 เอกสารโครงงาน
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                ลิ้งค์ Google Drive <span style={{ color: '#dc3545' }}>*</span>
              </Typography>
              <input
                className="form-control"
                style={{
                  border: '2px solid #28a745',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  transition: 'border-color 0.15s ease-in-out'
                }}
                {...register(`proposalCoop.link`)}
                placeholder="กรุณาใส่ลิงค์ Google Drive ของไฟล์โครงงาน PDF"
              />
              <Typography variant="caption" sx={{ mt: 1, color: '#6c757d', display: 'block' }}>
                💡 ตัวอย่าง: https://drive.google.com/file/d/FILE_ID/view
              </Typography>
            </Box>
          </Grid>

          {/* PDF Preview Section */}
          {watch("proposalCoop.link") && (
            <Grid item xs={12}>
              <Box sx={{ 
                backgroundColor: '#fff', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                mb: 2
              }}>
                <Typography variant="h6" sx={{ 
                  mb: 2, 
                  color: '#155724', 
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}>
                  📄 ตัวอย่างไฟล์โครงงาน
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, color: '#6c757d', display: 'block' }}>
                  💡 คลิกปุ่ม ⛶ มุมขวาบนเพื่อดูแบบเต็มจอ
                </Typography>
                <Box sx={{ 
                  border: '2px dashed #28a745', 
                  borderRadius: '8px', 
                  overflow: 'hidden',
                  backgroundColor: '#f8fff9'
                }}>
                  <PDFPreview
                    googleDriveUrl={watch("proposalCoop.link")}
                    height="350px"
                    title={`โครงงานสหกิจศึกษา - RequestID: ${watch("proposalCoop.req_id")}`}
                    showFullscreenButton={true}
                    pageCount={watch("proposalCoop.page_count") || null}
                  />
                </Box>
              </Box>
            </Grid>
          )}
          {/* Action Buttons Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              textAlign: 'center', 
              mt: 3,
              pt: 3,
              borderTop: '1px solid #e9ecef'
            }}>
              <Button
                variant="contained"
                color="success"
                size="large"
                disabled={
                  !(watch("proposalCoop.req_id") && watch("proposalCoop.link"))
                }
                onClick={() => {
                  if (watch("proposalCoop.id")) {
                    onHandleEditProposal(
                      watch("proposalCoop.req_id"),
                      watch("proposalCoop.link")
                    );
                  } else {
                    onHandleAddProposal(
                      watch("proposalCoop.req_id"),
                      watch("proposalCoop.link")
                    );
                  }
                }}
                sx={{ 
                  mr: 2, 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                {watch("proposalCoop.id") ? '✏️ อัพเดท' : '💾 บันทึก'}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setModalAddProposalPreviewOpen(false)}
                sx={{ 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                ❌ ยกเลิก
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ModalView>
  );

  const displayModalAddLogbookPreview = (
    <ModalView
      isModaOpen={modalAddLogbookPreviewOpen}
      setIsModalOpen={setModalAddLogbookPreviewOpen}
      onClose={() => {
        setModalAddLogbookPreviewOpen(null);
      }}
      title={"เพิ่มบันทึกการฝึกงาน Logbook แลรายงานความก้าวหน้า"}
    >
      <Box sx={{ 
        minWidth: "400px", 
        maxWidth: "600px", 
        maxHeight: "80vh",
        padding: "16px",
        overflowY: "auto"
      }}>
        <Grid container spacing={3}>
          {/* Header Information Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#f8f9fa', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                ข้อมูลพื้นฐาน
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                    Request ID
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`logbook.req_id`)}
                    readOnly
                    value={watch("logbook.req_id")?.value}
                    name="req_id"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                    Logbook ครั้งที่
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`logbook.no`)}
                    readOnly
                    value={watch("logbook.no")?.value}
                    name="no"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Google Drive Link Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                เอกสารแนบ
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                ลิ้งค์ Google Drive <span style={{ color: '#dc3545' }}>*</span>
              </Typography>
              <input
                className="form-control"
                style={{
                  border: '2px solid #007bff',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  transition: 'border-color 0.15s ease-in-out'
                }}
                {...register(`logbook.link`)}
                value={watch("logbook.link")?.value}
                name="link"
                placeholder="กรุณาใส่ลิงค์ Google Drive ของไฟล์ PDF"
                onChange={(e) => {
                  setValue("logbook.link", e.target.value);
                }}
              />
              <Typography variant="caption" sx={{ mt: 1, color: '#6c757d', display: 'block' }}>
                💡 ตัวอย่าง: https://drive.google.com/file/d/FILE_ID/view
              </Typography>
            </Box>
          </Grid>

          {/* PDF Preview Section */}
          {watch("logbook.link") && (
            <Grid item xs={12}>
              <Box sx={{ 
                backgroundColor: '#fff', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                mb: 2
              }}>
                <Typography variant="h6" sx={{ 
                  mb: 2, 
                  color: '#d32f2f', 
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}>
                  📄 ตัวอย่าง PDF
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, color: '#6c757d', display: 'block' }}>
                  💡 คลิกปุ่ม ⛶ มุมขวาบนเพื่อดูแบบเต็มจอ
                </Typography>
                <Box sx={{ 
                  border: '2px dashed #007bff', 
                  borderRadius: '8px', 
                  overflow: 'hidden',
                  backgroundColor: '#f8f9fa'
                }}>
                  <PDFPreview
                    googleDriveUrl={watch("logbook.link")}
                    height="350px"
                    title={`Logbook ครั้งที่ ${watch("logbook.no")} - RequestID: ${watch("logbook.req_id")}`}
                    showFullscreenButton={true}
                    pageCount={watch("logbook.page_count") || null}
                  />
                </Box>
              </Box>
            </Grid>
          )}

          {/* Action Buttons Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              textAlign: 'center', 
              mt: 3,
              pt: 3,
              borderTop: '1px solid #e9ecef'
            }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                disabled={
                  !(watch("logbook.link") !== null) || watch("logbook.link") == ""
                }
                onClick={() => {
                  onHandleAddLogbook(
                    watch("logbook.req_id"),
                    watch("logbook.no"),
                    watch("logbook.link")
                  );
                }}
                sx={{ 
                  mr: 2, 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                💾 บันทึก
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setModalAddLogbookPreviewOpen(false)}
                sx={{ 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                ❌ ยกเลิก
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ModalView>
  );

  const displayModalEditLogbookPreview = (
    <ModalView
      isModaOpen={modalEditLogbookPreviewOpen}
      setIsModalOpen={setModalEditLogbookPreviewOpen}
      onClose={() => {
        setModalEditLogbookPreviewOpen(null);
      }}
      title={"แก้ไขบันทึกการฝึกงาน Logbook แลรายงานความก้าวหน้า"}
    >
      <Box sx={{ 
        minWidth: "400px", 
        maxWidth: "600px", 
        maxHeight: "80vh",
        padding: "16px",
        overflowY: "auto"
      }}>
        <Grid container spacing={3}>
          {/* Header Information Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff3cd', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #ffeaa7',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#856404', fontWeight: 600, fontSize: '1.1rem' }}>
                📝 ข้อมูลที่แก้ไข
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#856404' }}>
                    Request ID
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#fffbf0',
                      border: '1px solid #ffeaa7',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`logbook.req_id`)}
                    readOnly
                    value={watch("logbook.req_id")?.value}
                    name="req_id"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#856404' }}>
                    Logbook ครั้งที่
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#fffbf0',
                      border: '1px solid #ffeaa7',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`logbook.no`)}
                    readOnly
                    value={watch("logbook.no")?.value}
                    name="no"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Google Drive Link Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                🔗 เอกสารแนบ (แก้ไข)
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                ลิ้งค์ Google Drive <span style={{ color: '#dc3545' }}>*</span>
              </Typography>
              <input
                className="form-control"
                style={{
                  border: '2px solid #ffc107',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  transition: 'border-color 0.15s ease-in-out'
                }}
                {...register(`logbook.link`)}
                value={watch("logbook.link")?.value}
                name="link"
                placeholder="กรุณาใส่ลิงค์ Google Drive ของไฟล์ PDF ที่แก้ไขแล้ว"
                onChange={(e) => {
                  setValue("logbook.link", e.target.value);
                }}
              />
              <Typography variant="caption" sx={{ mt: 1, color: '#6c757d', display: 'block' }}>
                💡 ตัวอย่าง: https://drive.google.com/file/d/FILE_ID/view
              </Typography>
            </Box>
          </Grid>

          {/* PDF Preview Section */}
          {watch("logbook.link") && (
            <Grid item xs={12}>
              <Box sx={{ 
                backgroundColor: '#fff', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                mb: 2
              }}>
                <Typography variant="h6" sx={{ 
                  mb: 2, 
                  color: '#d32f2f', 
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}>
                  📄 ตัวอย่าง PDF (แก้ไขแล้ว)
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, color: '#6c757d', display: 'block' }}>
                  💡 คลิกปุ่ม ⛶ มุมขวาบนเพื่อดูแบบเต็มจอ
                </Typography>
                <Box sx={{ 
                  border: '2px dashed #ffc107', 
                  borderRadius: '8px', 
                  overflow: 'hidden',
                  backgroundColor: '#fffbf0'
                }}>
                  <PDFPreview
                    googleDriveUrl={watch("logbook.link")}
                    height="350px"
                    title={`Logbook ครั้งที่ ${watch("logbook.no")} - RequestID: ${watch("logbook.req_id")} (แก้ไข)`}
                    showFullscreenButton={true}
                    pageCount={watch("logbook.page_count") || null}
                  />
                </Box>
              </Box>
            </Grid>
          )}

          {/* Action Buttons Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              textAlign: 'center', 
              mt: 3,
              pt: 3,
              borderTop: '1px solid #e9ecef'
            }}>
              <Button
                variant="contained"
                color="warning"
                size="large"
                disabled={
                  !(watch("logbook.link") !== null) || watch("logbook.link") == ""
                }
                onClick={() => {
                  onHandleEditLogbook(
                    watch("logbook.req_id"),
                    watch("logbook.no"),
                    watch("logbook.link")
                  );
                }}
                sx={{ 
                  mr: 2, 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  color: 'white'
                }}
              >
                ✏️ อัพเดท
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setModalEditLogbookPreviewOpen(false)}
                sx={{ 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                ❌ ยกเลิก
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ModalView>
  );

  const displayModalAddInternReportPreview = (
    <ModalView
      isModaOpen={modalAddInternReportPreviewOpen}
      setIsModalOpen={setModalAddInternReportPreviewOpen}
      onClose={() => {
        setModalAddInternReportPreviewOpen(null);
      }}
      title={"ส่งรายงานฝึกงาน 2 เดือน"}
    >
      <Box sx={{ 
        minWidth: "400px", 
        maxWidth: "600px", 
        maxHeight: "80vh",
        padding: "16px",
        overflowY: "auto"
      }}>
        <Grid container spacing={3}>
          {/* Header Information Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#e3f2fd', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #bbdefb',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#0d47a1', fontWeight: 600, fontSize: '1.1rem' }}>
                📊 ข้อมูลรายงานฝึกงาน
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#0d47a1' }}>
                    Request ID
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#f3f8ff',
                      border: '1px solid #bbdefb',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`internreport.req_id`)}
                    readOnly
                    value={watch("internreport.req_id")?.value}
                    name="req_id"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Google Drive Link Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                📝 เอกสารรายงาน
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                ลิ้งค์ Google Drive <span style={{ color: '#dc3545' }}>*</span>
              </Typography>
              <input
                className="form-control"
                style={{
                  border: '2px solid #2196f3',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  transition: 'border-color 0.15s ease-in-out'
                }}
                {...register(`internreport.link`)}
                value={watch("internreport.link")?.value}
                name="link"
                placeholder="กรุณาใส่ลิงค์ Google Drive ของไฟล์รายงานฝึกงาน PDF"
                onChange={(e) => {
                  setValue("internreport.link", e.target.value);
                }}
              />
              <Typography variant="caption" sx={{ mt: 1, color: '#6c757d', display: 'block' }}>
                💡 รายงานสรุปการฝึกงานระยะเวลา 2 เดือน
              </Typography>
            </Box>
          </Grid>

          {/* PDF Preview Section */}
          {watch("internreport.link") && (
            <Grid item xs={12}>
              <Box sx={{ 
                backgroundColor: '#fff', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                mb: 2
              }}>
                <Typography variant="h6" sx={{ 
                  mb: 2, 
                  color: '#0d47a1', 
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}>
                  📄 ตัวอย่างรายงานฝึกงาน
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, color: '#6c757d', display: 'block' }}>
                  💡 คลิกปุ่ม ⛶ มุมขวาบนเพื่อดูแบบเต็มจอ
                </Typography>
                <Box sx={{ 
                  border: '2px dashed #2196f3', 
                  borderRadius: '8px', 
                  overflow: 'hidden',
                  backgroundColor: '#f3f8ff'
                }}>
                  <PDFPreview
                    googleDriveUrl={watch("internreport.link")}
                    height="350px"
                    title={`รายงานฝึกงาน 2 เดือน - RequestID: ${watch("internreport.req_id")}`}
                    showFullscreenButton={true}
                    pageCount={watch("internreport.page_count") || null}
                  />
                </Box>
              </Box>
            </Grid>
          )}

          {/* Action Buttons Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              textAlign: 'center', 
              mt: 3,
              pt: 3,
              borderTop: '1px solid #e9ecef'
            }}>
              <Button
                variant="contained"
                color="info"
                size="large"
                disabled={
                  !(watch("internreport.link") !== null) ||
                  watch("internreport.link") == ""
                }
                onClick={() => {
                  onHandleAddInternReport(
                    watch("internreport.req_id"),
                    watch("internreport.link")
                  );
                }}
                sx={{ 
                  mr: 2, 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                📤 ส่งรายงาน
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setModalAddInternReportPreviewOpen(false)}
                sx={{ 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                ❌ ยกเลิก
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ModalView>
  );

  const displayModalAddCoopReportPreview = (
    <ModalView
      isModaOpen={modalAddCoopReportPreviewOpen}
      setIsModalOpen={setModalAddCoopReportPreviewOpen}
      onClose={() => {
        setModalAddCoopReportPreviewOpen(null);
      }}
      title={"ส่งรายงานสหกิจศึกษา"}
    >
      <Box sx={{ 
        minWidth: "400px", 
        maxWidth: "600px", 
        maxHeight: "80vh",
        padding: "16px",
        overflowY: "auto"
      }}>
        <Grid container spacing={3}>
          {/* Header Information Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#e8f5e8', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #c3e6cb',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#155724', fontWeight: 600, fontSize: '1.1rem' }}>
                📊 ข้อมูลรายงานสหกิจศึกษา
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#155724' }}>
                    Request ID
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#f8fff9',
                      border: '1px solid #c3e6cb',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`coopreport.req_id`)}
                    readOnly
                    value={watch("coopreport.req_id")?.value}
                    name="req_id"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Google Drive Link Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                📝 เอกสารรายงาน
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                ลิ้งค์ Google Drive <span style={{ color: '#dc3545' }}>*</span>
              </Typography>
              <input
                className="form-control"
                style={{
                  border: '2px solid #28a745',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  transition: 'border-color 0.15s ease-in-out'
                }}
                {...register(`coopreport.link`)}
                value={watch("coopreport.link")?.value}
                name="link"
                placeholder="กรุณาใส่ลิงค์ Google Drive ของไฟล์รายงานสหกิจศึกษา PDF"
                onChange={(e) => {
                  setValue("coopreport.link", e.target.value);
                }}
              />
              <Typography variant="caption" sx={{ mt: 1, color: '#6c757d', display: 'block' }}>
                💡 รายงานสรุปการปฏิบัติงานสหกิจศึกษา
              </Typography>
            </Box>
          </Grid>

          {/* PDF Preview Section */}
          {watch("coopreport.link") && (
            <Grid item xs={12}>
              <Box sx={{ 
                backgroundColor: '#fff', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                mb: 2
              }}>
                <Typography variant="h6" sx={{ 
                  mb: 2, 
                  color: '#155724', 
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}>
                  📄 ตัวอย่างรายงานสหกิจศึกษา
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, color: '#6c757d', display: 'block' }}>
                  💡 คลิกปุ่ม ⛶ มุมขวาบนเพื่อดูแบบเต็มจอ
                </Typography>
                <Box sx={{ 
                  border: '2px dashed #28a745', 
                  borderRadius: '8px', 
                  overflow: 'hidden',
                  backgroundColor: '#f8fff9'
                }}>
                  <PDFPreview
                    googleDriveUrl={watch("coopreport.link")}
                    height="350px"
                    title={`รายงานสหกิจศึกษา - RequestID: ${watch("coopreport.req_id")}`}
                    showFullscreenButton={true}
                    pageCount={watch("coopreport.page_count") || null}
                  />
                </Box>
              </Box>
            </Grid>
          )}

          {/* Action Buttons Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              textAlign: 'center', 
              mt: 3,
              pt: 3,
              borderTop: '1px solid #e9ecef'
            }}>
              <Button
                variant="contained"
                color="success"
                size="large"
                disabled={
                  !(watch("coopreport.link") !== null) ||
                  watch("coopreport.link") == ""
                }
                onClick={() => {
                  onHandleAddCoopReport(
                    watch("coopreport.req_id"),
                    watch("coopreport.link")
                  );
                }}
                sx={{ 
                  mr: 2, 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                📤 ส่งรายงาน
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setModalAddCoopReportPreviewOpen(false)}
                sx={{ 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                ❌ ยกเลิก
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ModalView>
  );

  const displayModalEditInternReportPreview = (
    <ModalView
      isModaOpen={modalEditInternReportPreviewOpen}
      setIsModalOpen={setModalEditInternReportPreviewOpen}
      onClose={() => {
        setModalEditInternReportPreviewOpen(null);
      }}
      title={"แก้ไขรายงานฝึกงาน 2 เดือน"}
    >
      <Box sx={{ 
        minWidth: "400px", 
        maxWidth: "600px", 
        maxHeight: "80vh",
        padding: "16px",
        overflowY: "auto"
      }}>
        <Grid container spacing={3}>
          {/* Header Information Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff3cd', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #ffeaa7',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#856404', fontWeight: 600, fontSize: '1.1rem' }}>
                📝 แก้ไขรายงานฝึกงาน
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#856404' }}>
                    Request ID
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#fffbf0',
                      border: '1px solid #ffeaa7',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`internreport.req_id`)}
                    readOnly
                    value={watch("internreport.req_id")?.value}
                    name="req_id"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Google Drive Link Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                🔗 เอกสารรายงาน (แก้ไข)
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                ลิ้งค์ Google Drive <span style={{ color: '#dc3545' }}>*</span>
              </Typography>
              <input
                className="form-control"
                style={{
                  border: '2px solid #ffc107',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  transition: 'border-color 0.15s ease-in-out'
                }}
                {...register(`internreport.link`)}
                value={watch("internreport.link")?.value}
                name="link"
                placeholder="กรุณาใส่ลิงค์ Google Drive ของไฟล์รายงานฝึกงานที่แก้ไขแล้ว"
                onChange={(e) => {
                  setValue("internreport.link", e.target.value);
                }}
              />
              <Typography variant="caption" sx={{ mt: 1, color: '#6c757d', display: 'block' }}>
                💡 รายงานสรุปการฝึกงานระยะเวลา 2 เดือน (เวอร์ชันแก้ไข)
              </Typography>
            </Box>
          </Grid>

          {/* PDF Preview Section */}
          {watch("internreport.link") && (
            <Grid item xs={12}>
              <Box sx={{ 
                backgroundColor: '#fff', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                mb: 2
              }}>
                <Typography variant="h6" sx={{ 
                  mb: 2, 
                  color: '#856404', 
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}>
                  📄 ตัวอย่างรายงานฝึกงาน (แก้ไขแล้ว)
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, color: '#6c757d', display: 'block' }}>
                  💡 คลิกปุ่ม ⛶ มุมขวาบนเพื่อดูแบบเต็มจอ
                </Typography>
                <Box sx={{ 
                  border: '2px dashed #ffc107', 
                  borderRadius: '8px', 
                  overflow: 'hidden',
                  backgroundColor: '#fffbf0'
                }}>
                  <PDFPreview
                    googleDriveUrl={watch("internreport.link")}
                    height="350px"
                    title={`แก้ไขรายงานฝึกงาน 2 เดือน - RequestID: ${watch("internreport.req_id")}`}
                    showFullscreenButton={true}
                    pageCount={watch("internreport.page_count") || null}
                  />
                </Box>
              </Box>
            </Grid>
          )}

          {/* Action Buttons Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              textAlign: 'center', 
              mt: 3,
              pt: 3,
              borderTop: '1px solid #e9ecef'
            }}>
              <Button
                variant="contained"
                color="warning"
                size="large"
                disabled={
                  !(watch("internreport.link") !== null) ||
                  watch("internreport.link") == ""
                }
                onClick={() => {
                  onHandleEditInternReport(
                    watch("internreport.req_id"),
                    watch("internreport.link")
                  );
                }}
                sx={{ 
                  mr: 2, 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  color: 'white'
                }}
              >
                ✏️ อัพเดทรายงาน
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setModalEditInternReportPreviewOpen(false)}
                sx={{ 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                ❌ ยกเลิก
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ModalView>
  );

  const displayModalEditCoopReportPreview = (
    <ModalView
      isModaOpen={modalEditCoopReportPreviewOpen}
      setIsModalOpen={setModalEditCoopReportPreviewOpen}
      onClose={() => {
        setModalEditCoopReportPreviewOpen(null);
      }}
      title={"แก้ไขรายงานสหกิจศึกษา"}
    >
      <Box sx={{ 
        minWidth: "400px", 
        maxWidth: "600px", 
        maxHeight: "80vh",
        padding: "16px",
        overflowY: "auto"
      }}>
        <Grid container spacing={3}>
          {/* Header Information Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff3cd', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #ffeaa7',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#856404', fontWeight: 600, fontSize: '1.1rem' }}>
                📝 แก้ไขรายงานสหกิจศึกษา
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#856404' }}>
                    Request ID
                  </Typography>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#fffbf0',
                      border: '1px solid #ffeaa7',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '14px'
                    }}
                    {...register(`coopreport.req_id`)}
                    readOnly
                    value={watch("coopreport.req_id")?.value}
                    name="req_id"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Google Drive Link Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              backgroundColor: '#fff', 
              padding: '16px', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              mb: 2
            }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600, fontSize: '1.1rem' }}>
                🔗 เอกสารรายงาน (แก้ไข)
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#6c757d' }}>
                ลิ้งค์ Google Drive <span style={{ color: '#dc3545' }}>*</span>
              </Typography>
              <input
                className="form-control"
                style={{
                  border: '2px solid #ffc107',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  transition: 'border-color 0.15s ease-in-out'
                }}
                {...register(`coopreport.link`)}
                value={watch("coopreport.link")?.value}
                name="link"
                placeholder="กรุณาใส่ลิงค์ Google Drive ของไฟล์รายงานสหกิจศึกษาที่แก้ไขแล้ว"
                onChange={(e) => {
                  setValue("coopreport.link", e.target.value);
                }}
              />
              <Typography variant="caption" sx={{ mt: 1, color: '#6c757d', display: 'block' }}>
                💡 รายงานสรุปการปฏิบัติงานสหกิจศึกษา (เวอร์ชันแก้ไข)
              </Typography>
            </Box>
          </Grid>

          {/* PDF Preview Section */}
          {watch("coopreport.link") && (
            <Grid item xs={12}>
              <Box sx={{ 
                backgroundColor: '#fff', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                mb: 2
              }}>
                <Typography variant="h6" sx={{ 
                  mb: 2, 
                  color: '#856404', 
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}>
                  📄 ตัวอย่างรายงานสหกิจศึกษา (แก้ไขแล้ว)
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, color: '#6c757d', display: 'block' }}>
                  💡 คลิกปุ่ม ⛶ มุมขวาบนเพื่อดูแบบเต็มจอ
                </Typography>
                <Box sx={{ 
                  border: '2px dashed #ffc107', 
                  borderRadius: '8px', 
                  overflow: 'hidden',
                  backgroundColor: '#fffbf0'
                }}>
                  <PDFPreview
                    googleDriveUrl={watch("coopreport.link")}
                    height="350px"
                    title={`แก้ไขรายงานสหกิจศึกษา - RequestID: ${watch("coopreport.req_id")}`}
                    showFullscreenButton={true}
                    pageCount={watch("coopreport.page_count") || null}
                  />
                </Box>
              </Box>
            </Grid>
          )}

          {/* Action Buttons Section */}
          <Grid item xs={12}>
            <Box sx={{ 
              textAlign: 'center', 
              mt: 3,
              pt: 3,
              borderTop: '1px solid #e9ecef'
            }}>
              <Button
                variant="contained"
                color="warning"
                size="large"
                disabled={
                  !(watch("coopreport.link") !== null) ||
                  watch("coopreport.link") == ""
                }
                onClick={() => {
                  onHandleEditCoopReport(
                    watch("coopreport.req_id"),
                    watch("coopreport.link")
                  );
                }}
                sx={{ 
                  mr: 2, 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  color: 'white'
                }}
              >
                ✏️ อัพเดทรายงาน
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setModalEditCoopReportPreviewOpen(false)}
                sx={{ 
                  minWidth: '120px',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                ❌ ยกเลิก
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ModalView>
  );

  const getCompanyList = async () => {
    getCompany()
      .then((res) => {
        const list = res.map((company) => {
          return {
            label: company.name,
            value: company.id,
            data: company,
          };
        });

        setOptionsCompany(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  useEffect(() => {
    getInternData();
  }, [optionsCompany]);

  // Fetch intern manual details when internDetail changes
  useEffect(() => {
    const fetchInternManualDetails = async () => {
      if (internDetail.length > 0) {
        const approvedInterns = internDetail.filter((el) => el.status == "2");
        if (approvedInterns.length > 0) {
          try {
            // Fetch details for all approved interns
            const allInternManualDetails = [];
            for (const intern of approvedInterns) {
              const details = await getInternManualById(intern.req_id);
              if (details && details.length > 0) {
                allInternManualDetails.push(...details);
              }
            }
            
            setInternManualDetail(allInternManualDetails);
          } catch (error) {
            console.error("Error fetching intern manual details:", error);
          }
        }
      }
    };

    fetchInternManualDetails();
  }, [internDetail]);

  // Helper function to find intern manual detail by req_id
  const getInternManualByReqId = (reqId) => {
    return internManualDetail.find(detail => detail?.intern_request_id == reqId);
  };

  const displayInternData = (
    <div className="card mb-3">
      <Accordion
        expanded={expanded === "panel0"}
        onChange={handleChange("panel0")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          
        >
          <Typography>ข้อมูลการยื่นความประสงค์</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <div
            id="carouselExampleIndicators"
            className="carousel carousel-dark slide pb-4"
            data-bs-ride="carousel"
           // data-bs-interval={false}
          >
            <div className="carousel-indicators">
              {internDetail.length &&
                internDetail.map((item1, cIndex) => {
                  // หาสไลด์ที่เหมาะสมที่สุดสำหรับแสดงเป็นค่าเริ่มต้น
                  const currentDate = new Date();
                  const approvedItems = internDetail.filter(item => item?.status == "2");
                  
                  let bestIndex = 0;
                  if (approvedItems.length > 1) {
                    // ถ้ามี Approved มากกว่า 1 ให้พิจารณาช่วงเวลา
                    const currentInternship = approvedItems.find(item => {
                      const startDate = new Date(item?.start_date);
                      const endDate = new Date(item?.end_date);
                      return currentDate >= startDate && currentDate <= endDate;
                    });
                    
                    if (currentInternship) {
                      // ถ้าพบรายการที่กำลังฝึกงานอยู่
                      bestIndex = internDetail.findIndex(item => item?.req_id === currentInternship.req_id);
                    } else {
                      // ถ้าไม่มีที่กำลังฝึกงาน ให้เลือกรายการล่าสุด
                      const latestApproved = approvedItems.sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0];
                      bestIndex = internDetail.findIndex(item => item?.req_id === latestApproved.req_id);
                    }
                  } else if (approvedItems.length === 1) {
                    // ถ้ามี Approved เพียงรายการเดียว
                    bestIndex = internDetail.findIndex(item => item?.status == "2");
                  }
                  
                  return (
                    <div
                      key={`indicator-${cIndex}`}
                      type="button"
                      data-bs-target={`#carouselExampleIndicators`}
                      data-bs-slide-to={cIndex}
                      className={cIndex == bestIndex && "active"}
                      aria-current="true"
                      aria-label={`companyIndex-${cIndex}`}
                    />
                  );
                })}
            </div>

            <div className="carousel-inner">
              { 
              internDetail.length
                ? internDetail.map((item, index) => { 
                  if(!item){return null;}
                  // หาสไลด์ที่เหมาะสมที่สุดสำหรับแสดงเป็นค่าเริ่มต้น
                  const currentDate = new Date();
                  const approvedItems = internDetail.filter(item => item?.status == "2");
                  
                  let bestIndex = 0;
                  if (approvedItems.length > 1) {
                    // ถ้ามี Approved มากกว่า 1 ให้พิจารณาช่วงเวลา
                    const currentInternship = approvedItems.find(item => {
                      const startDate = new Date(item?.start_date);
                      const endDate = new Date(item?.end_date);
                      return currentDate >= startDate && currentDate <= endDate;
                    });
                    
                    if (currentInternship) {
                      // ถ้าพบรายการที่กำลังฝึกงานอยู่
                      bestIndex = internDetail.findIndex(item => item?.req_id === currentInternship.req_id);
                    } else {
                      // ถ้าไม่มีที่กำลังฝึกงาน ให้เลือกรายการล่าสุด
                      const latestApproved = approvedItems.sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0];
                      bestIndex = internDetail.findIndex(item => item?.req_id === latestApproved.req_id);
                    }
                  } else if (approvedItems.length === 1) {
                    // ถ้ามี Approved เพียงรายการเดียว
                    bestIndex = internDetail.findIndex(item => item?.status == "2");
                  }
                  
                    return (
                      
                      <div
                        key={`carousel-item-${index}`}
                        className={`carousel-item ${index == bestIndex && "active"}`}
                      >
                        <form
                          action="https://eng.buu.ac.th/internship/interntest/update-company-detail.php"
                          method="post"
                        >
                          <div className="text-end">
                            {onEdit &&
                              (item.status == "1" || item.status == "2") && 
                              isNaN(getUsername) && (
                                <button
                                  className="btn btn-primary mx-2 btn-sm"
                                  type="submit"
                                >
                                  บันทึก
                                </button>
                              )}

                            {(item.status == "1" ||
                              (item.status == "2" && isNaN(getUsername))) && (
                              <BsPencilSquare
                                size="1rem"
                                onClick={onEditClick}
                                role="button"
                              />
                            )}
                          </div>
                          <table className="table table-sm my-2">
                            <tbody>
                              <tr>
                                <th>สถานประกอบการ</th>
                                <td>
                                  <span className="badge bg-info">
                                    ID : {item?.cp_id}
                                  </span>{" "}
                                  {item?.companyDetail?.label}{" "}
                                </td>
                              </tr>
                              <tr>
                                <th>ที่อยู่สถานประกอบการ</th>
                                <td>
                                  {item?.companyDetail?.data.address} ต.
                                  {item?.companyDetail?.data.subdistrict} อ.
                                  {item?.companyDetail?.data.district} จ.
                                  {item?.companyDetail?.data.province}{" "}
                                  {item?.companyDetail?.data.zip}
                                </td>
                              </tr>
                              <tr>
                                <th>ชื่อผู้ประสานงาน</th>
                                <td>
                                  <input
                                    readOnly={!onEdit || !isNaN(getUsername)}
                                    className={`form-control ps-0 ${
                                      (!onEdit || !isNaN(getUsername)) && "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="co_name"
                                    defaultValue={item?.co_name }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>ตำแหน่ง</th>
                                <td>
                                  <input
                                    readOnly={!onEdit || !isNaN(getUsername)}
                                    className={`form-control ps-0 ${
                                      (!onEdit || !isNaN(getUsername)) && "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="co_pos"
                                    defaultValue={item?.co_pos}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Email ผู้ประสานงาน</th>
                                <td>
                                  <input
                                    readOnly={!onEdit || !isNaN(getUsername)}
                                    className={`form-control ps-0 ${
                                      (!onEdit || !isNaN(getUsername)) && "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="co_email"
                                    defaultValue={item?.co_email}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>เบอร์โทร</th>
                                <td>
                                  <input
                                    readOnly={!onEdit || !isNaN(getUsername)}
                                    className={`form-control ps-0 ${
                                      (!onEdit || !isNaN(getUsername)) && "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="cp_tel"
                                    defaultValue={item?.cp_tel}
                                  />
                                </td>
                              </tr>
                              {item.comment && item.comment !== "-" && (
                                <tr>
                                  <th>หมายเหตุ</th>
                                  <td style={{ color: "#b31717" }}>
                                    <input
                                      readOnly={!onEdit || !isNaN(getUsername)}
                                      className={`form-control ps-0 ${
                                        (!onEdit || !isNaN(getUsername)) && "field-editable"
                                      }`}
                                      style={{ color: "inherit" }}
                                      name="comment"
                                      defaultValue={item?.comment}
                                    />
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <th>ประเภทการฝึกงาน</th>
                                <td>
                                  {matchOptions(
                                    internType,
                                    item?.type_internship
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>ช่วงวันที่</th>
                                <td>
                                  {!onEdit ? (
                                    <>
                                      {convertDateToString(item?.start_date)} -{" "}
                                      {convertDateToString(item?.end_date)}
                                    </>
                                  ) : (
                                    <div className="d-flex">
                                      <input
                                        readOnly={!onEdit || !isNaN(getUsername)}
                                        className={`form-control w-50 ps-0 ${
                                          (!onEdit || !isNaN(getUsername)) && "field-editable"
                                        }`}
                                        style={{ color: "inherit" }}
                                        name="start_date"
                                        type="date"
                                        defaultValue={item?.start_date}
                                      />
                                      <div>-</div>
                                      <input
                                        readOnly={!onEdit || !isNaN(getUsername)}
                                        className={`form-control w-50 ps-0 ${
                                          (!onEdit || !isNaN(getUsername)) && "field-editable"
                                        }`}
                                        style={{ color: "inherit" }}
                                        name="end_date"
                                        type="date"
                                        defaultValue={item?.end_date}
                                      />
                                    </div>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>สถานะเอกสาร</th>
                                <td>
                                  {item?.status == 0 && (
                                    <span className="badge bg-danger">
                                      ยกเลิก
                                    </span>
                                  )}
                                  {item?.status == 1 && (
                                    <span className="badge bg-success">
                                      Active
                                    </span>
                                  )}
                                  {item?.status == 2 && (
                                    <span className="badge bg-success">
                                      Approved
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <input
                            name="req_id"
                            className="d-none"
                            value={item?.req_id}
                          />
                        </form>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* <div className="card-header">
          <h4 className="card-title mb-0">
            <div className="d-flex justify-content-between">
              <div>ข้อมูลการออกไปฝึกงานและสหกิจศึกษา</div>
            </div>
          </h4>
        </div> */}

      {internDetail.length &&
        internDetail
          .sort((a, b) => a.req_id - b.req_id)
          .filter((el) => el.status == "2")
          .map((item, index) => {
            const offsetIndex = index + 1;
            
            // ตรวจสอบว่าอยู่ในช่วงวันที่ฝึกงานหรือไม่
            const currentDate = new Date();
            const startDate = new Date(item?.start_date);
            const endDate = new Date(item?.end_date);
            const isInInternshipPeriod = currentDate >= startDate && currentDate <= endDate;

            return (
              <Accordion
                 expanded={isInInternshipPeriod ? "panel" + offsetIndex : expanded === "panel" + offsetIndex}
                 onChange={handleChange("panel" + offsetIndex)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  id="panel1a-header"
                  sx={{ bgcolor: "#bfcad3" }}
                >
                  <Typography sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{" ข้อมูลการฝึกงาน/สหกิจศึกษา "}</span>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      {isInInternshipPeriod ? (
                        <span className="badge bg-success" style={{ fontSize: '12px' }}>
                          กำลังฝึกงาน
                        </span>
                      ) : (
                        currentDate > endDate && (
                          <span className="badge bg-secondary" style={{ fontSize: '12px' }}>
                            ฝึกงานเสร็จสิ้น
                          </span>
                        )
                      )}
                      <span className="badge bg-info">
                        RequestID : {item?.req_id}
                      </span>
                    </div>
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <div>
                    <form action="https://eng.buu.ac.th/internship/interntest/update-company-detail.php" method="post">
                      <div className="text-end">
                        {onEdit &&
                          (item.status == "1" || item.status == "2") && 
                          isNaN(getUsername) && (
                            <button
                              className="btn btn-primary mx-2 btn-sm"
                              type="submit"
                            >
                              บันทึก
                            </button>
                          )}

                        {(item.status == "1" ||
                          (item.status == "2" && isNaN(getUsername))) && (
                          <BsPencilSquare
                            size="1rem"
                            onClick={onEditClick}
                            role="button"
                          />
                        )}
                      </div>
                      <table className="table table-sm my-2">
                        <tbody>
                          <tr>
                            <th style={{ width: '50px' }}>สถานประกอบการ</th>
                            <td style={{ width: '200px' }}>
                              <span className="badge bg-info">
                                ID : {item?.cp_id}
                              </span>{" "}
                              {item?.companyDetail?.label}{" "}
                            </td>
                          </tr>
                          <tr>
                            <th>ที่อยู่</th>
                            <td>
                              {item?.companyDetail?.data.address} ต.
                              {item?.companyDetail?.data.subdistrict} อ.
                              {item?.companyDetail?.data.district} จ.
                              {item?.companyDetail?.data.province}{" "}
                              {item?.companyDetail?.data.zip}
                            </td>
                          </tr>

                          <tr>
                            <th>ประเภทการฝึกงาน</th>
                            <td>
                              {matchOptions(internType, item?.type_internship)}
                            </td>
                          </tr>
                          <tr>
                            <th>ช่วงวันที่</th>
                            <td>
                              {!onEdit ? (
                                <>
                                  {convertDateToString(item?.start_date)} -{" "}
                                  {convertDateToString(item?.end_date)}
                                </>
                              ) : (
                                <div className="d-flex">
                                  <input
                                    readOnly={!onEdit || !isNaN(getUsername)}
                                    className={`form-control w-50 ps-0 ${
                                      (!onEdit || !isNaN(getUsername)) && "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="start_date"
                                    type="date"
                                    defaultValue={item?.start_date}
                                  />
                                  <div>-</div>
                                  <input
                                    readOnly={!onEdit || !isNaN(getUsername)}
                                    className={`form-control w-50 ps-0 ${
                                      (!onEdit || !isNaN(getUsername)) && "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="end_date"
                                    type="date"
                                    defaultValue={item?.end_date}
                                  />
                                </div>
                              )}
                            </td>
                          </tr>
                          {/* <tr>
                              <th>สถานะเอกสาร</th>
                              <td>
                                {item?.status == 0 && (
                                  <span className="badge bg-danger">
                                    ยกเลิก
                                  </span>
                                )}
                                {item?.status == 1 && (
                                  <span className="badge bg-success">
                                    Active
                                  </span>
                                )}
                                {item?.status == 2 && (
                                  <span className="badge bg-success">
                                    Approved
                                  </span>
                                )}
                              </td>
                            </tr>
                           
                              <tr>
                                <th></th>
                                <td>
                                  <div
                                    className="ms-2 text-secondary"
                                    onClick={() => setIsOpenModalForm(true)}
                                    type="button"
                                  >
                                    <GrDocumentVerified /> คำร้องขอฝึกงานที่อนุมัติ
                                  </div>
                                </td>
                              </tr> */}

                          <tr>
                            <th>หนังสือส่งตัว</th>
                            <td>
                              <div className="ms-2 text-secondary">
                              {item?.documentReqStudent?.doc_sending_url ?
                                  <a href={item?.documentReqStudent?.doc_sending_url} target="_blank">
                                <GrDocumentVerified /> {"  "}
                                <strong><span style={{ color: 'blue' }}>{item?.documentReqStudent?.idm_id}</span></strong>
                               
                                 </a>
                                  : item?.documentReqStudent?.idm_id}
                               
                               
                               </div>
                            </td>
                          </tr>

                          <tr>
                            <th>อาจารย์นิเทศ</th>
                            <td>{item?.supervisorName}</td>
                          </tr>

                        

                          <tr>
                            <th></th>
                            <td>
                            <Stack
                                        direction="row"
                                        alignItems="center"
                                        divider={
                                          <Divider
                                            orientation="vertical"
                                            flexItem
                                          />
                                        }
                                        spacing={2}
                                      >
                              <Link
                                to={`/intern-manual?req_id=${item?.req_id}`}
                                target="_blank"
                              >
                                <MapsHomeWorkIcon fontSize="small" />{" "}
                                แจ้งรายละเอียดการปฏิบัติงาน
                              </Link>
                              {getInternManualByReqId(item?.req_id)?.markby && (
                                <Tooltip title={`ผู้ประเมิน : ${getInternManualByReqId(item?.req_id)?.markby} ${getInternManualByReqId(item?.req_id)?.markedDate?.split(" ")[0]}`}>
                                  <div>
                                    <Rating
                                      size="small"
                                      name="read-only"
                                      value={parseInt(getInternManualByReqId(item?.req_id)?.mark) || 0}
                                      readOnly
                                    />
                                  </div>
                                </Tooltip>)}
                                </Stack>
                            </td>
                          </tr>

                          {!!logbooklist.length &&
                            logbooklist?.map((el) => {
                              
                              return (
                                el.req_id == item?.req_id && (
                                  <tr>
                                    { el?.no == 1 && <th>บันทึกการฝึกงาน</th> || <th></th>}
                                      
                                    <td>
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        divider={
                                          <Divider
                                            orientation="vertical"
                                            flexItem
                                          />
                                        }
                                        spacing={2}
                                      >
                                        <div>
                                          <a href={el?.link} target="_blank">
                                            <PictureAsPdfIcon fontSize="small" />{" "}
                                            Logbook#{el?.no}{" "}
                                          </a>

                                          <Tooltip title="แก้ไข">
                                            <IconButton
                                              onClick={() =>
                                                onEditLogbook(
                                                  el.req_id,
                                                  el?.no,
                                                  el?.link
                                                )
                                              }
                                            >
                                              <EditIcon
                                                fontSize="small"
                                                color="primary"
                                                sx={{ width: 13, height: 13 }}
                                              />
                                            </IconButton>
                                          </Tooltip>
                                        </div>

                                        {el?.markby && (
                                         <Tooltip title={`ผู้ประเมิน : ${el?.markby} ${el?.markedDate?.split(" ")[0]}`}>
                                          <div>
                                            <Rating
                                              size="small"
                                              name="read-only"
                                              value={el?.mark}
                                              readOnly
                                            />
                                          </div>
                                        </Tooltip> )}

                                      </Stack>
                                    </td>
                                  </tr>
                                )
                              );
                            })}
                          <tr>
                            <th></th>
                            <td>
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<AddCircleIcon fontSize="small" />}
                                sx={{ fontSize: 11, fontWeight: "medium" }}
                                onClick={() =>
                                  onAddLogbook(
                                    item?.req_id,
                                    logbooklist?.filter((el) => el.req_id == item?.req_id).length > 0
                                      ? (parseInt(logbooklist?.filter((el) => el.req_id == item?.req_id)
                                        .sort((b, a) => a.no - b.no).find((el) => el.no)?.no) + 1) : 1
                                  )
                                }
                              >
                                เพิ่ม Logbook#
                                {logbooklist?.filter((el) => el.req_id == item?.req_id).length > 0
                                  ? (parseInt(logbooklist?.filter((el) => el.req_id == item?.req_id)
                                    .sort((b, a) => a.no - b.no).find((el) => el.no)?.no) + 1) : 1
                                }
                              </Button>
                            </td>
                          </tr>




                          {!!item?.internreport[0] && (
                            <tr>
                              <th>ฝึกงาน 2 เดือน</th>
                              <td>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  divider={
                                    <Divider orientation="vertical" flexItem />
                                  }
                                  spacing={2}
                                >
                                  <div>
                                    <a
                                      href={item?.internreport[0]?.link}
                                      target="_blank"
                                    >
                                      <AssignmentIcon fontSize="small" />{" "}
                                      รายงานฝึกงาน 2 เดือน
                                    </a>

                                    <Tooltip title="แก้ไข">
                                      <IconButton
                                        onClick={() =>
                                          onEditInternReport(
                                            item?.internreport[0]?.req_id,
                                            item?.internreport[0]?.link
                                          )
                                        }
                                      >
                                        <EditIcon
                                          fontSize="small"
                                          color="primary"
                                          sx={{ width: 13, height: 13 }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </div>

                                  {/* <Rating
                                          size="small"
                                          name="read-only"
                                          value={el.mark}
                                          readOnly
                                        /> */}
                                </Stack>
                              </td>
                            </tr>
                          )}

                          
                          {item?.type_internship != 1 ? (             
                          <tr>
                            <th>สหกิจศึกษา</th>
                            <td>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  divider={
                                    <Divider
                                      orientation="vertical"
                                      flexItem
                                    />
                                  }
                                  spacing={2}
                                >
                              {item.proposal[0] && item.proposal[0].link ? (
                                <Box>
                                  <Button
                                    size="small"
                                    variant="text"
                                    startIcon={<Assignment fontSize="small" />}
                                    sx={{ fontSize: 11, fontWeight: "medium" }}
                                    onClick={() => {
                                      window.open(
                                        item.proposal[0].link,
                                        "_blank",
                                        "noopener,noreferrer"
                                      );
                                    }}
                                  >
                                    รายละเอียดโครงงานสหกิจศึกษาฯ
                                  </Button>
                                      <Tooltip title="แก้ไข">
                                        <IconButton
                                          onClick={() =>
                                            onAddProposalCoop(item)
                                          }
                                        >
                                          <EditIcon
                                            fontSize="small"
                                            color="primary"
                                            sx={{ width: 13, height: 13 }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                  
                                </Box>
                              ) : (
                                <Button
                                  size="small"
                                  variant="text"
                                  startIcon={<AddCircleIcon fontSize="small" />}
                                  sx={{ fontSize: 11, fontWeight: "medium" }}
                                  onClick={() => {
                                    onAddProposalCoop(item);
                                  }}
                                >
                                  แจ้งรายละเอียดโครงงานสหกิจศึกษาฯ
                                </Button>
                                
                                  )}
                                  {item.proposal[0]?.markby && (
                                    <Tooltip title={`ผู้ประเมิน : ${item.proposal[0]?.markby} ${item.proposal[0]?.markedDate?.split(" ")[0]}`}>
                                      <div>
                                        <Rating
                                          size="small"
                                          name="read-only"
                                          value={item.proposal[0]?.mark}
                                          readOnly
                                        />
                                      </div>
                                    </Tooltip>)}

                                </Stack>
                            </td>
                          </tr>
                          ) : null}

                          



                          {!!item?.coopreport[0]&& item?.type_internship != 1  && (
                            <tr>
                              <th></th>
                              <td>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  divider={
                                    <Divider orientation="vertical" flexItem />
                                  }
                                  spacing={2}
                                >
                                  <div>
                                    <a
                                      href={item?.coopreport[0]?.link}
                                      target="_blank"
                                    >
                                      <AssignmentIcon fontSize="small" />{" "}
                                      รายงานสหกิจศึกษา
                                    </a>

                                    <Tooltip title="แก้ไข">
                                      <IconButton
                                        onClick={() =>
                                          onEditCoopReport(
                                            item?.coopreport[0]?.req_id,
                                            item?.coopreport[0]?.link
                                          )
                                        }
                                      >
                                        <EditIcon
                                          fontSize="small"
                                          color="primary"
                                          sx={{ width: 13, height: 13 }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </div>

                                  {/* <Rating
                                          size="small"
                                          name="read-only"
                                          value={el.mark}
                                          readOnly
                                        /> */}
                                </Stack>
                              </td>
                            </tr>
                          )}



                          

                  

                          {!item?.internreport[0] && (
                            <tr>
                              <th></th>
                              <td>
                                <Button
                                  size="small"
                                  variant="text"
                                  startIcon={<AddCircleIcon fontSize="small" />}
                                  sx={{ fontSize: 11, fontWeight: "medium" }}
                                  onClick={() =>
                                    onAddInternReport(item?.req_id)
                                  }
                                >
                                  ส่งรายงานฝึกงาน 2 เดือน
                                </Button>
                              </td>
                            </tr>
                            
                          )}




                          {item?.type_internship != 1 ? (
                            !item?.coopreport[0] && (
                              <tr>
                                <th></th>
                                <td>
                                  <Button
                                    size="small"
                                    variant="text"
                                    startIcon={<AddCircleIcon fontSize="small" />}
                                   
                                    sx={{ fontSize: 11, fontWeight: "medium", color: 'red' }}
                                    onClick={() =>
                                      onAddCoopReport(item?.req_id)
                                    }
                                  >
                                    ส่งรายงานสหกิจศึกษา
                                  </Button>
                                </td>
                              </tr>
                              
                            )
                            
                          ) : null}

                        </tbody>
                      </table>
                      <input
                        name="req_id"
                        className="d-none"
                        value={item?.req_id}
                      />
                    </form>
                  </div>
                </AccordionDetails>
              </Accordion>
            );
          })}
    </div>
  );

  return (
    <div>
      {internDetail.length ? (
        displayInternData
      ) : (
        <div className="card h-100">
          <div className="card-body d-flex justify-content-center align-items-center">
            <div>
              {getUsername == st_id ? (
                <Link to="/request-form" className="btn btn-light">
                  ยื่นความประสงค์ขอฝึกงาน
                </Link>
              ) : (
                <div>ยังไม่ได้ยื่นความประสงค์ขอฝึกงาน</div>
              )}
              <div className="text-center">
                <GiFactory fontSize="100px" />
              </div>
            </div>
          </div>
        </div>
      )}
      {displayModalProposalPreview}
      {displayModalAddLogbookPreview}
      {displayModalEditLogbookPreview}
      {displayModalAddInternReportPreview}
      {displayModalEditInternReportPreview}
      {displayModalAddCoopReportPreview}
      {displayModalEditCoopReportPreview}
    </div>
  );
};

export default InternData;
